import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
});

const approvals_server = axios.create({
    baseURL: process.env.REACT_APP_FCM_API_URL || process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
});

const reports_server = axios.create({
    baseURL: process.env.REACT_APP_API_REPORTS_URL,
    headers: { 'Content-Type': "application/json" },
});

const socket_server = axios.create({
    baseURL: process.env.REACT_APP_SOCKET_URL,
    headers: { 'Content-Type': "application/json" },
})


export class OrdersFetchAPI {
    static async getOrderByCode(order_code, by_qr, branchoffice_id) {
        const res = await server(`/order/${order_code}/code/${by_qr}/branchoffice/${branchoffice_id}`, {
            method: "get"
        });
        return res
    }

    static async getsOrdersByStatusByType(business_code, branchoffice_code, status_id, token) {
        const res = await server(`/orders/${business_code}/business/${branchoffice_code}/branch/${status_id}/status`, {
            method: "get",
            headers: {
                "x-access-token": token
            }
        });
        return res
    }

    static async getOrderById(order_id, token) {
        const res = await server(`/order/${order_id}`, {
            method: 'get',
            headers: {
                "x-access-token": token
            }
        });
        return res
    }

    static async updateOrderStatus(state_id, order_id, groups, token) {
        const res = await server(`/order/${order_id}`, {
            method: 'put',
            data: { "state_id": state_id, "groups": groups },
            headers: {
                "x-access-token": token
            }
        });
        return res
    }

    //Function to update orders data 
    static async updateOrders(token, by_id, data) {
        let final_url_string = "/order?";
        //If we are updating by id we add it to the url
        if (by_id === true) {
            final_url_string = final_url_string + "by_id=true";
        }
        //We make the request
        const res = await server(`${final_url_string}`, {
            method: 'put',
            headers: {
                "x-access-token": token
            },
            data: data
        });
        return res
    }

    static async getTransactionsByBranchOffice(business_code, branchoffice_code, minDate, maxDate, token) {
        const res = await reports_server(`/branch/orders/${branchoffice_code}/${business_code}/${minDate}/${maxDate}`, {
            method: "get",
            headers: {
                "x-access-token": token
            }
        });
        return res
    }

    static async getTransactionsByBranchOfficePaymentMethod(business_code, branchoffice_code, minDate, maxDate, paymentmethod_id, token) {
        const res = await reports_server(`/branch/paymentmethod/orders/${branchoffice_code}/${business_code}/${minDate}/${maxDate}/${paymentmethod_id}`, {
            method: "get",
            headers: {
                "x-access-token": token
            }
        });
        return res
    }

    //Function to get temporal orders by code 
    static async getTempOrderByCode(order_code, business_code, branchoffice_code, token) {
        const res = await approvals_server(`/temp/order/${order_code}/${business_code}/${branchoffice_code}`, {
            method: "get",
            headers: {
                "x-access-token": token
            }
        });
        return res
    }

    static async getTemporalOrdersByBranch(business_code, branchoffice_code, minDate, maxDate, token) {
        const res = await approvals_server(`/temp/branch/orders/${branchoffice_code}/${business_code}/${minDate}/${maxDate}`, {
            method: "get",
            headers: {
                "x-access-token": token
            }
        });
        return res
    }

    //Function to get all the report info 
    static async getTransactionsByBranchOfficePaymentMethodbyUser(business_code, branchoffice_code, minDate, maxDate, paymentmethod_id, user_id, token, devolution, tips, consiliation, selectedUserOption, payment_integration_id, selectedWaiterOption, selectedEventOption, branchCodesParam) {

        console.log("SelectedUserOption en la api", selectedUserOption)
        console.log("SelectedEventOption en la api", selectedEventOption)
        console.log("payment_integration_id en la api", payment_integration_id)
        //We check if the branchoffice is sendend
        if (branchoffice_code === undefined) {
            branchoffice_code = 0;
        }
        //Final ulr
        let final_url_string = `/branch/paymentmethod/orders/user/${branchoffice_code}/${business_code}/${minDate}/${maxDate}/${paymentmethod_id}/${user_id}`;
        //If devolution is true we add it to the url
        if (devolution) {
            final_url_string = final_url_string + `?devolutions=${devolution}`
        }
        //If tips is true we add it to the url
        if (tips) {
            //We check if the url has a query string already
            if (final_url_string.includes("?") === true) {
                final_url_string = final_url_string + `&justtips=${tips}`
            } else {
                final_url_string = final_url_string + `?justtips=${tips}`
            }
        }
        //If consiliation is true we add it to the url
        if (consiliation) {
            //We check if the url has a query string already
            if (final_url_string.includes("?") === true) {
                final_url_string = final_url_string + `&consiliation=${consiliation}`
            } else {
                final_url_string = final_url_string + `?consiliation=${consiliation}`
            }
        }
        //If user_id is true we add it to the url
        if (selectedUserOption !== undefined && selectedUserOption !== null && selectedUserOption !== "" && selectedUserOption !== false) {
            //We check if the url has a query string already
            if (final_url_string.includes("?") === true) {
                final_url_string = final_url_string + `&cashierselected=true`
            } else {
                final_url_string = final_url_string + `?cashierselected=true`
            }
        }
        //If selectedEventOption is true we add it to the url
        if (selectedEventOption !== undefined && selectedEventOption !== null && selectedEventOption !== "" && selectedEventOption !== false) {
            if (final_url_string.includes("?") === true) {
                final_url_string = final_url_string + `&event_id=${selectedEventOption}`
            } else {
                final_url_string = final_url_string + `?event_id=${selectedEventOption}`
            }
        }
        //If payment_integration_id is true we add it to the url
        if (payment_integration_id !== undefined && payment_integration_id !== null && payment_integration_id !== "" && payment_integration_id !== false) {
            if (final_url_string.includes("?") === true) {
                final_url_string = final_url_string + `&payment_integration_id=${payment_integration_id}`
            } else {
                final_url_string = final_url_string + `?payment_integration_id=${payment_integration_id}`
            }
        }
        //If selectedWaiterOption is true we add it to the url
        if (selectedWaiterOption !== undefined && selectedWaiterOption !== null && selectedWaiterOption !== "" && selectedWaiterOption !== false) {
            if (final_url_string.includes("?") === true) {
                final_url_string = final_url_string + `&waiterselected=${selectedWaiterOption}`
            } else {
                final_url_string = final_url_string + `?waiterselected=${selectedWaiterOption}`
            }
        }
        //If branchCodesParam is true we add it to the url
        if (branchCodesParam !== undefined && branchCodesParam !== null && branchCodesParam.length > 0) {
            const branchCodesString = branchCodesParam.join(",");
            if (final_url_string.includes("?") === true) {
                final_url_string = final_url_string + `&branch_codes=${branchCodesString}`
            } else {
                final_url_string = final_url_string + `?branch_codes=${branchCodesString}`
            }
        }


        //We make the request
        const res = await reports_server(final_url_string, {
            method: "get",
            headers: {
                "x-access-token": token
            }
        });
        return res
    }

    //Function to get all the report info 
    static async getTransactionsByBranchOfficePaymentMethodbyTable(business_code, branchoffice_code, minDate, maxDate, payment_method_id, user_id, machine_id, table_id, token, client_id, selectedUserOption) {
        let final_url_string = `/branch/paymentmethod/orders/user/${branchoffice_code}/${business_code}/${minDate}/${maxDate}/${payment_method_id}/${user_id}/${machine_id}/${table_id}/${client_id}`

        //If user_id is true we add it to the url
        if (selectedUserOption !== undefined && selectedUserOption !== null && selectedUserOption !== "") {
            //We check if the url has a query string already
            final_url_string = final_url_string + `?cashierselected=true`
        }
        //If user_id is true we add it to the url
        const res = await reports_server(final_url_string, {
            method: "get",
            headers: {
                "x-access-token": token
            }
        });
        return res
    }

    static async getTransactionsByBranchOfficePaymentMethodbyMachines(business_code, branchoffice_code, minDate, maxDate, paymentmethod_id, user_id, machine_id, token, selectedUserOption, payment_integration_id, selectedEventOption, branchCodesParam) {
        let final_url_string = `/branch/paymentmethod/orders/user/${branchoffice_code}/${business_code}/${minDate}/${maxDate}/${paymentmethod_id}/${user_id}/${machine_id}`

        //If user_id is true we add it to the url
        if (selectedUserOption !== undefined && selectedUserOption !== null && selectedUserOption !== "") {
            //We check if the url has a query string already
            final_url_string = final_url_string + `?cashierselected=true`
        }
        //If payment_integration_id is true we add it to the url
        if (payment_integration_id !== undefined && payment_integration_id !== null && payment_integration_id !== "" && payment_integration_id !== false && payment_integration_id !== 0) {
            if (selectedUserOption !== undefined && selectedUserOption !== null && selectedUserOption !== "") {
                final_url_string = final_url_string + `&payment_integration_id=${payment_integration_id}`
            } else {
                final_url_string = final_url_string + `?payment_integration_id=${payment_integration_id}`
            }
        }

        //We check if selectedEventOption is true we add it to the url
        if (selectedEventOption !== undefined && selectedEventOption !== null && selectedEventOption !== "" && selectedEventOption !== false && selectedEventOption !== 0) {
            if ((selectedUserOption !== undefined && selectedUserOption !== null && selectedUserOption !== "") || (payment_integration_id !== undefined && payment_integration_id !== null && payment_integration_id !== "" && payment_integration_id !== false && payment_integration_id !== 0)) {
                final_url_string = final_url_string + `&event_id=${selectedEventOption}`
            } else {
                final_url_string = final_url_string + `?event_id=${selectedEventOption}`
            }
        }

        //We check if branchCodesParam is true we add it to the url
        if (branchCodesParam !== undefined && branchCodesParam !== null && branchCodesParam.length > 0) {
            const branchCodesString = branchCodesParam.join(",");
            if ((selectedUserOption !== undefined && selectedUserOption !== null && selectedUserOption !== "") || (payment_integration_id !== undefined && payment_integration_id !== null && payment_integration_id !== "" && payment_integration_id !== false && payment_integration_id !== 0) || (selectedEventOption !== undefined && selectedEventOption !== null && selectedEventOption !== "" && selectedEventOption !== false && selectedEventOption !== 0)) {
                final_url_string = final_url_string + `&branch_codes=${branchCodesString}`
            } else {
                final_url_string = final_url_string + `?branch_codes=${branchCodesString}`
            }
        }


        //If user_id is true we add it to the url
        const res = await reports_server(final_url_string, {
            method: "get",
            headers: {
                "x-access-token": token
            }
        });
        return res
    }

    //Function to get temporal orders by code 
    static async updateTempOrder(data, token) {
        const res = await approvals_server(`/temp/order`, {
            method: "put",
            data,
            headers: {
                "x-access-token": token
            }
        });
        return res
    }

    //Funtion to get sales reports 
    static async getSalesReport(minDate, maxDate, branchoffice_id, machine_id, token) {
        const res = await server(`/sales_report/${minDate}/${maxDate}/${branchoffice_id}/${machine_id}/report`, {
            method: "GET",
            headers: {
                "x-access-token": token
            }
        });
        return res
    }

    static async getProductSalesReport(minDate, maxDate, branchoffice_id, machine_id, token, event_id, selectedBranchCodes) {
        let url = `/product_report/${minDate}/${maxDate}/${branchoffice_id}/${machine_id}/report`;
        if (event_id) {
            url += `?event_id=${event_id}`;
        }
        if (selectedBranchCodes && selectedBranchCodes.length > 0) {
            const branchCodesString = selectedBranchCodes.join(",");
            url += event_id ? `&branchoffices=${branchCodesString}` : `?branchoffices=${branchCodesString}`;
        }

        const res = await server(url, {
            method: "GET",
            headers: {
                "x-access-token": token
            }
        });
        return res
    }

    //Function to get temporal orders by machine 
    static async getTempOrderByMachine(machine_code, business_code, branch_code, isdiscount, token) {
        const res = await server(`/temp/machine/order/${machine_code}/${business_code}/${branch_code}/${isdiscount}`, {
            method: "GET",
            headers: {
                "x-access-token": token
            }
        });
        return res
    }

    //Function to get the cashier orders 
    static async getOrdersByUser(business_code, user_code, minDate, maxDate) {
        const res = await server(`/user/${user_code}/${minDate}/${maxDate}/${business_code}/business/orders`, {
            method: "get"
        });
        return res
    }

    static async getNumberOrder(branchoffice_id, token) {
        const res = await server(`/last_order/${branchoffice_id}`, {
            method: "GET",
            headers: {
                "x-access-token": token
            }
        });
        return res
    }


    static async getOrderToPrint(transaction_code, token) {
        const res = await server(`/print/order/${transaction_code}`, {
            method: "GET",
            headers: {
                "x-access-token": token
            }
        });
        return res
    }


    static async getOrderByStatusBusinessBranchOrderTypeDate(order_type, business_code, branchoffice_code, status_id, minDate, maxDate, token) {
        let final_string_order_type_status = "order_type=" + order_type.join("&order_type=") + "&status_id=" + status_id.join("&status_id=")
        const res = await server(`/orders/${business_code}/business/${branchoffice_code}/branch/${minDate}/minDate/${maxDate}/maxDate/status/order_type?${final_string_order_type_status}`, {
            method: "GET",
            headers: {
                "x-access-token": token
            }
        });
        return res
    }



    static async getTransactionByCode(transaction_code, business_code, branch_code, token) {
        const res = await server(`/order/${transaction_code}/transaction_code/${branch_code}/branchoffice/${business_code}/business`, {
            method: "GET",
            headers: {
                "x-access-token": token
            }
        });
        return res
    }

    static async updateVoucher(order_id, data, token) {
        const res = await server(`/order/${order_id}`, {
            method: "PUT",
            data: data,
            headers: {
                "x-access-token": token
            }
        });
        return res
    }
}




